"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _theme = require("@vds/theme");
var _toggles = require("@vds-core/toggles");
var propTypes = {
  /**
   * If provided, the toggle will be rendered in the inverted state.
   */
  inverted: _propTypes["default"].bool,
  /**
   * Will hide or display text inside the toggle.
   */
  hideText: _propTypes["default"].bool,
  /**
   * @deprecated
   * If provided, the Toggle will be toggled to its active state
   */
  checked: _propTypes["default"].bool,
  /**
   * @deprecated
   * Value given to toggle that will be returned by event handler function given to handleToggle prop
   */
  handleToggle: _propTypes["default"].func
};
var defaultProps = {
  inverted: false,
  hideText: false
};
var Toggle = function Toggle(props) {
  var inverted = props.inverted,
    hideText = props.hideText;
  function _calculateBackgroundColor(disabled, on, surface) {
    if (disabled && surface === "dark") {
      return _theme.colors.coolGray10;
    } else if (disabled && surface === "light") {
      return _theme.colors.coolGray3;
    } else if (!disabled && surface === "dark" && !on) {
      return _theme.colors.coolGray6;
    } else if (on) {
      return _theme.colors.green;
    } else {
      return _theme.colors.black;
    }
  }
  function _calculateTextColor(disabled, surface) {
    if (disabled && surface === "dark") {
      return _theme.colors.coolGray6;
    } else if (disabled && surface === "light") {
      return _theme.colors.coolGray1;
    } else {
      return _theme.colors.white;
    }
  }
  function _calculateButtonColor(disabled, surface) {
    if (disabled && surface === "dark") {
      return _theme.colors.coolGray6;
    } else if (disabled && surface === "light") {
      return _theme.colors.coolGray1;
    } else {
      return _theme.colors.white;
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_toggles.Toggle, (0, _extends2["default"])({}, props, {
    on: props.checked !== undefined ? props.checked : props.on,
    onChange: props.handleToggle || props.onChange,
    textPosition: "center",
    showText: hideText ? false : true,
    surface: inverted ? "dark" : "light",
    calculateBackgroundColor: _calculateBackgroundColor,
    calculateTextColor: _calculateTextColor,
    calculateButtonColor: _calculateButtonColor,
    toggleHeight: 24,
    knobSize: 20,
    knobLeftPosition: 28
  }));
};
Toggle.propTypes = propTypes;
Toggle.defaultProps = defaultProps;
var _default = exports["default"] = Toggle;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/toggles/dist/cjs/components/Toggle.js
// module id = 1617
// module chunks = 0